import { IAutocompleteCarrierProps } from 'transfix-ui/components/AutocompleteCarrier'
import { ICarrierOptionCarrier } from '../types'
import { getCarrierAutocompleteOptionText } from './getCarrierAutocompleteOptionText'

export const getCarrierAutocompleteConfig: IAutocompleteCarrierProps['getOptionsConfig'] = data => {
  const { searchCarrierApplications = [] } = data || {}
  return {
    options: searchCarrierApplications,
    groupIndex: 1,
    mapOption: (carrier: ICarrierOptionCarrier) => {
      const { id } = carrier || {}
      return {
        id,
        text: getCarrierAutocompleteOptionText(carrier),
      }
    },
  }
}
